// @flow

import FormLabel from './form-label'

export default FormLabel
